export const ROUTE_PATHS = {
  HOME: '/',
  SERVICES: '/services',
  PORTFOLIO: '/portfolio',
  CONTACT: '/contact',
} as const;

export interface Service {
  id: string;
  title: string;
  description: string;
  icon: string;
  features: string[];
  imageKey: string;
}

export interface Project {
  id: string;
  title: string;
  category: 'residential' | 'commercial' | 'consultation' | 'furniture';
  description: string;
  imageKey: string;
  year: number;
  location?: string;
}

export interface TeamMember {
  id: string;
  name: string;
  role: string;
  bio: string;
  imageKey?: string;
}

export interface Testimonial {
  id: string;
  clientName: string;
  projectType: string;
  content: string;
  rating: number;
}

export const COMPANY_INFO = {
  name: 'YKE Multi-Service',
  tagline: 'Votre partenaire de prestige',
  location: 'Sipim, Abidjan',
  email: 'YKE_Multi_Service@proton.me',
  phone: '+225 07 58 56 77 94',
  description: 'Expert en design d\'intérieur et ameublement sur mesure, alliant excellence internationale et savoir-faire local ivoirien.',
} as const;

export const SERVICE_CATEGORIES = {
  RESIDENTIAL: 'residential',
  COMMERCIAL: 'commercial',
  CONSULTATION: 'consultation',
  FURNITURE: 'furniture',
} as const;

export const PROJECT_CATEGORIES = {
  RESIDENTIAL: 'residential',
  COMMERCIAL: 'commercial',
  CONSULTATION: 'consultation',
  FURNITURE: 'furniture',
} as const;
